export enum NewRelicLogLevel {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  INFO = "INFO",
  WARN = "WARN",
  DEBUG = "DEBUG",
  TRACE = "TRACE",
}

interface NRApiStatusDetails {
  source: "API";
  operation: string;
  response?: unknown;
  status?: number;
  url?: string;
  [key: string]: unknown;
}

interface NRApplicationStatusDetails {
  source: "APPLICATION";
  operation: string;
  [key: string]: unknown;
}

export type NRStatusDetails = NRApiStatusDetails | NRApplicationStatusDetails;

export interface LogStatusProps {
  type: NewRelicLogLevel;
  message: string;
  statusDetails?: NRStatusDetails;
}
